import Factory from '@/utils/request'

const baseURL = '/portal/api'

export default Factory(
  {
    baseURL
  },
  () => false
)
